import React from 'react';
import { LinkComponentProps } from '@origin-digital/ods-types';
import { ChatLink } from '../ChatLink';

// special keyword to identify that we want to
// use the livechat link
export const LIVECHAT_MARKDOWN_HREF = 'LIVECHAT';

// Handles links when the MarkDownLite component is used
// To use livechat link:
// <MarkdownLite>text... [Click here for livechat](LIVECHAT)</MarkdownLite>
// To use a normal link:
// <MarkdownLite>text.. [Origin Energy](https://originenergy.com.au)</MarkdownLite>

export const MarkdownLinkHandler = React.forwardRef<any, LinkComponentProps>((props, ref) => {
  const { href, children } = props;
  if (href === LIVECHAT_MARKDOWN_HREF) {
    return <ChatLink>{children}</ChatLink>;
  }
  return (
    <a ref={ref} {...props} href={href}>
      {children}
    </a>
  );
});
